'use client';

import type { FC } from 'react';
import { cn } from '../../utils/cn';

interface SkeletonProps {
  className?: string;
}

export const Skeleton: FC<SkeletonProps> = ({ className }) => (
  <div className={cn('animate-skeleton bg-[linear-gradient(90deg,rgba(255,255,255,0.05)_0%,rgba(255,255,255,0.1)_50%,rgba(255,255,255,0.05)_100%)] bg-[length:200px_100%] rounded', className)} />
);
